// project hash key
// e921d896b24ee51ad95dc303a034758da1187532b0a44189bd99aa333255781b

import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import DeliveryInfo from '../../components/pages/lotteryDetail/DeliveryInfo';
import FloatPanel from '../../components/pages/lotteryDetail/FloatPanel';
import InfoWChance from '../../components/pages/lotteryDetail/InfoWChance';
import LineUpAward from '../../components/pages/lotteryDetail/LineUpAward';
import NoteSP from '../../components/pages/lotteryDetail/NoteSP';
import OverViews from '../../components/pages/lotteryDetail/OverViews';
import PhotoArea from '../../components/pages/lotteryDetail/PhotoArea';
import { LotteryApis } from '../../services/lotteryDetail';
import { useAppDispatch } from '../../store';
import { hideLoading, showLoading } from '../../store/features/loadingPage';
import queryString from 'query-string';
import './styles.scss';
import './customSlider.scss';
import useMessage from '../../components/common/toast/UseMessage';
import { listsErrorNotShowToast } from '../../constants';
import useMatatag from '../../hooks/useMatatag';
import BackGroundDot from '../../../assets/imgs/common/background_dots.png';
import styled from 'styled-components';
import ScrollButton from '../../components/pages/top/backToTop/ScrollButton';

export const StyledBackgroundDot = styled.div`
  background-image: radial-gradient(ellipse at center, #e1e1e1 10%, transparent 10%),
    radial-gradient(ellipse at center, #e1e1e1 10%, transparent 10%);
  background-color: #ffffff;
  background-position: 15px 0px, 45px 29px;
  background-size: 20px 20px;
  height: 100%;
  width: 100%;
`;
export default function LotteryDetail() {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const [data, setData] = useState();

  const pathLotteryTrial = '/trial';
  const pathSite = history.location.pathname;
  const { id } = useParams();

  useMatatag({
    title: data?.lottery_event?.name,
    description: data?.lottery_event?.description,
    url: `${process.env.APP_DOMAIN}lottery/${id}`,
    image: data?.lottery_event?.image?.image_url,
    keyword:
      'くじロードONLINE,kujiroad, オンラインスクラッチくじ, オンラインくじ,' +
      data?.lottery_event?.name,
    twitterCard: 'summary_large_image',
    twitterSite: '@bushi_creative',
  });

  const search = queryString.parse(history.location.search);

  const { openMessageError } = useMessage();

  const getLotteryDetail = async () => {
    dispatch(showLoading());
    try {
      const res = await LotteryApis.getDetail(id, search.verify ? search : {});
      const { data } = res;
      setData(data);
    } catch (error) {
      if (!listsErrorNotShowToast.includes(Number(error?.response?.status))) {
        openMessageError(error);
      }
    } finally {
      dispatch(hideLoading());
    }
  };

  const getLotteryTrialDetail = async () => {
    dispatch(showLoading());
    try {
      const res = await LotteryApis.getDetailTrial();
      const { data } = res;
      setData(data);
    } catch (error) {
      if (!listsErrorNotShowToast.includes(Number(error?.response?.status))) {
        openMessageError(error);
      }
    } finally {
      dispatch(hideLoading());
    }
  };

  useEffect(() => {
    if (pathSite === pathLotteryTrial) {
      getLotteryTrialDetail();
    } else {
      getLotteryDetail();
    }
  }, []);

  return (
    <div className="bg-white">
      {data && (
        <>
          <PhotoArea data={data} />
          <StyledBackgroundDot>
            <OverViews data={data} />
            <LineUpAward data={data} />
            <InfoWChance data={data} />
            <NoteSP />
            <DeliveryInfo data={data} />
            <ScrollButton className="scroll-float-panel" />
          </StyledBackgroundDot>
        </>
      )}
    </div>
  );
}
